<template>
  <v-container
    id="data-management"
    tag="section"
  >
    <base-resource-grid
      color="teal"
      icon="mdi-basket"
      plural-name="Products"
      singular-name="Product"
      allow-expand
      :headers="headers"
      :resource="productResource"
      :actions="actions"
      @handleAction="handleAction"
    >
      <template v-slot:editForm="bindings">
        <v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="bindings.editedItem.product"
              :error-messages="bindings.formErrors.Product"
              label="Product"
            />
            <base-resource-select
              v-if="bindings && bindings.editedItem"
              label="Product Type"
              item-text="productType"
              item-value="id"
              bind-text="productType"
              bind-value="productTypeId"
              :bind-item="bindings.editedItem"
              :error-messages="bindings.formErrors.ProductTypeId"
              :resource="productTypeResource"
            />
          </v-col>
        </v-row>
      </template>
    </base-resource-grid>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
    <base-history-dialog
      resource-endpoint="productHistory/"
      id-field="productId"
      title-field="product"
      color="teal"
      :columns="headers"
      :item="historyItem"
      @hide="historyItem = null"
    />
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'Products',

    data: () => ({
      productTypes: null,
      headers: [
        {
          text: 'Product',
          value: 'product',
        },
        {
          text: 'Product Type',
          value: 'productType',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      productResource: new TroodyApi('product/'),

      historyItem: null,

      productTypeResource: new TroodyApi('productType/'),

      errorMessage: null,

      displayError: false,
    }),

    methods: {
      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },

      showError (error, msg) {
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },
    },
  }
</script>
